(() => {
  const EVENT_NAMESPACE = 'northport';

  const normalizeDimension = (value, fallback) => {
    const normalized = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 64);

    return normalized || fallback;
  };

  const publish = (eventName, data) => {
    if (!window.Shopify?.analytics?.publish) return;

    try {
      window.Shopify.analytics.publish(`${EVENT_NAMESPACE}:${eventName}`, {
        schema_version: 1,
        ...data,
      });
    } catch (_error) {
      // Analytics must never interfere with navigation or form confirmation.
    }
  };

  const publishContactSuccesses = () => {
    document.querySelectorAll('[data-ntp-contact-success]').forEach((status) => {
      if (status.dataset.ntpAnalyticsPublished === 'true') return;

      status.dataset.ntpAnalyticsPublished = 'true';
      publish('contact_submit_success', {
        form_location: normalizeDimension(status.dataset.ntpFormLocation, 'contact_form'),
      });
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-ntp-analytics-event]');
    if (!trigger) return;

    const eventName = normalizeDimension(trigger.dataset.ntpAnalyticsEvent, 'interaction');
    publish(eventName, {
      button_location: normalizeDimension(trigger.dataset.ntpAnalyticsLocation, 'unknown'),
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', publishContactSuccesses, { once: true });
  } else {
    publishContactSuccesses();
  }
})();
